var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BlBackdrop",
        {
          attrs: {
            title: "Edit availability",
            label: _vm.submitLoading
              ? "Updating"
              : _vm.isRecurring
              ? "Next"
              : "Update",
            disabled: _vm.isDisabledSubmit,
            submitLoading: _vm.submitLoading
          },
          on: {
            "backdrop-close": function($event) {
              return _vm.$emit("close-modal")
            },
            "backdrop-action": _vm.onNextToRecurring
          }
        },
        [
          _c(
            "div",
            {
              class: {
                "overflow-y-auto":
                  _vm.conflictedByRoom.length || _vm.conflictedByUser.length
              },
              style: { width: "40rem", maxHeight: "calc(100vh - 14rem)" }
            },
            [
              _vm.modalLoading
                ? _c("div", { staticClass: "grid place-items-center h-100" }, [
                    _c("div", { staticClass: "blum-loader" })
                  ])
                : _vm.availability
                ? _c("div", { staticClass: "flex flex-col gap-4 px-8" }, [
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center gap-1 px-1 rounded h-7 bg-tulip-100"
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "w-6 h-6",
                            attrs: { icon: "calendar-blank", color: "tulip-7" }
                          }),
                          _vm._v(" "),
                          _c("BlTextSubtitle3", {
                            staticClass: "text-tulip-700",
                            attrs: {
                              text: _vm.displayDate({
                                date: _vm.availabilityDate,
                                format: "ddd, DD MMMM YYYY"
                              })
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.availability.repetition_type !== "not_repeat"
                      ? _c(
                          "div",
                          [
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "This availability is part of a recurring schedule that repeats every"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold",
                              attrs: {
                                text:
                                  _vm.availability.interval +
                                  " " +
                                  _vm.availability.repetition_type +
                                  "(s)"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", { attrs: { text: "on" } }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold",
                              attrs: { text: _vm.repetitionText }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", { attrs: { text: "and" } }),
                            _vm._v(" "),
                            _vm.availability.is_never_end
                              ? _c("BlTextBody2", {
                                  staticClass: "font-bold",
                                  attrs: { text: "continues indefinitely." }
                                })
                              : _c("BlTextBody2", {
                                  staticClass: "font-bold",
                                  attrs: {
                                    text:
                                      "ends on " +
                                      _vm.displayDate({
                                        date:
                                          _vm.availability.end_date ||
                                          _vm.availability.end_after,
                                        fornat: "DD MMMM YYYY"
                                      }) +
                                      "."
                                  }
                                })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "user", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _vm.kindInput === "for_therapist"
                          ? _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c("BlSelectBox", {
                                  staticClass: "w-96",
                                  attrs: {
                                    search: "",
                                    placeholder: "Select therapist",
                                    options: _vm.defaultTherapistOptions,
                                    fetchProperty: {
                                      url:
                                        "/api/v1/users?sort=name_asc&status=active&query=",
                                      dataKey: "users",
                                      countKey: "total_users",
                                      optionKeys: { value: "id", label: "name" }
                                    },
                                    disabled: _vm.availability.user_id !== null
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.therapistInput = $event
                                    }
                                  },
                                  model: {
                                    value: _vm.therapistInput,
                                    callback: function($$v) {
                                      _vm.therapistInput = $$v
                                    },
                                    expression: "therapistInput"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "BlTooltip",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.isDisabledSetAsOpenRoom
                                          ? {
                                              key: "tooltip",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-col w-40 gap-1 text-center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  This availability already has ongoing and/or completed\n                  appointments, so it cannot be open room availability.\n                "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          : null
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("BlInputButton", {
                                      attrs: {
                                        type: "plain",
                                        label: "Set as open room",
                                        disabled: _vm.isDisabledSetAsOpenRoom
                                      },
                                      on: {
                                        clicked: function($event) {
                                          _vm.kindInput = "open_room"
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kindInput === "open_room"
                          ? _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c("BlSelectBox", {
                                  key: "open-room-placeholder",
                                  staticClass: "w-112",
                                  attrs: {
                                    options: [
                                      {
                                        value: 0,
                                        label:
                                          "Open room - available to everyone"
                                      }
                                    ],
                                    disabled: ""
                                  },
                                  model: {
                                    value: _vm.openRoomInput,
                                    callback: function($$v) {
                                      _vm.openRoomInput = $$v
                                    },
                                    expression: "openRoomInput"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "BlTooltip",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.isDisabledRemoveOpenRoom
                                          ? {
                                              key: "tooltip",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-col w-40 gap-1 text-center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  This availability already has appointments, so it cannot be\n                  reassigned to a specific therapist.\n                "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          : null
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("BlInputButton", {
                                      attrs: {
                                        type: "plain",
                                        label: "Remove",
                                        disabled: _vm.isDisabledRemoveOpenRoom
                                      },
                                      on: {
                                        clicked: function($event) {
                                          _vm.kindInput = "for_therapist"
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "clock-outline", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlSelectBox", {
                          staticClass: "w-64",
                          attrs: {
                            search: "",
                            placeholder: "From",
                            options: _vm.startTimeOptions
                          },
                          on: {
                            change: function($event) {
                              _vm.startTimeInput = $event
                            }
                          },
                          model: {
                            value: _vm.startTimeInput,
                            callback: function($$v) {
                              _vm.startTimeInput = $$v
                            },
                            expression: "startTimeInput"
                          }
                        }),
                        _vm._v(" "),
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "arrow-right", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlSelectBox", {
                          key: "end-time-" + _vm.startTimeInput,
                          staticClass: "w-62",
                          attrs: {
                            search: "",
                            placeholder: "To",
                            options: _vm.endTimeOptions
                          },
                          on: {
                            change: function($event) {
                              _vm.endTimeInput = $event
                            }
                          },
                          model: {
                            value: _vm.endTimeInput,
                            callback: function($$v) {
                              _vm.endTimeInput = $$v
                            },
                            expression: "endTimeInput"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.enableBranch
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "w-6 h-6",
                              attrs: { icon: "location", color: "slate-6" }
                            }),
                            _vm._v(" "),
                            _c("BlSelectBox", {
                              staticClass: "w-136",
                              attrs: {
                                type: "branch",
                                search: "",
                                placeholder: "Select branch",
                                options: _vm.defaultBranchOptions,
                                fetchProperty: {
                                  url: "/api/v1/branches?sort=name_asc&query=",
                                  dataKey: "branches",
                                  countKey: "total_count",
                                  optionKeys: {
                                    value: "id",
                                    label: "name",
                                    color: "color",
                                    backgroundColor: "background_color"
                                  }
                                },
                                disabled: !_vm.endTimeInput,
                                drop: "up"
                              },
                              on: {
                                change: function($event) {
                                  _vm.branchInput = $event
                                }
                              },
                              model: {
                                value: _vm.branchInput,
                                callback: function($$v) {
                                  _vm.branchInput = $$v
                                },
                                expression: "branchInput"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "door", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlSelectBox", {
                          key: "room-" + _vm.branchInput,
                          staticClass: "w-136",
                          attrs: {
                            search: "",
                            placeholder: _vm.roomSelectLoading
                              ? "Loading..."
                              : "Select room",
                            options: _vm.roomOptions,
                            disabled: !_vm.endTimeInput,
                            drop: "up"
                          },
                          on: {
                            change: function($event) {
                              _vm.roomInput = $event
                            }
                          },
                          model: {
                            value: _vm.roomInput,
                            callback: function($$v) {
                              _vm.roomInput = $$v
                            },
                            expression: "roomInput"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isShowInfoOrphanAppointments && !_vm.isRecurring
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex items-start gap-2 px-3 py-2 rounded bg-cornflower-200"
                          },
                          [
                            _c("BlIcon", {
                              staticClass: "w-6 h-6",
                              attrs: { icon: "info", color: "cornflower-8" }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("BlTextBody2", {
                                  staticClass: "text-cornflower-800",
                                  attrs: {
                                    text: "By switching the availability from"
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "font-bold text-cornflower-800",
                                  attrs: { text: _vm.availability.user.name }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "text-cornflower-800",
                                  attrs: { text: "to" }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "font-bold text-cornflower-800",
                                  attrs: { text: "'Open room'," }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "text-cornflower-800",
                                  attrs: { text: "all" }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "font-bold text-cornflower-800",
                                  attrs: {
                                    text:
                                      _vm.availability.appointments.length +
                                      " appointment(s)"
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "text-cornflower-800",
                                  attrs: { text: "on" }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "font-bold text-cornflower-800",
                                  attrs: {
                                    text:
                                      _vm.displayDate({
                                        date: _vm.availabilityDate,
                                        format: "DD MMMM YYYY"
                                      }) + ","
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "text-cornflower-800",
                                  attrs: {
                                    text:
                                      "will no longer have an assigned therapist and will need to be reassigned."
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.conflictedByRoom.length || _vm.conflictedByUser.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex items-start gap-2 px-3 py-2 rounded bg-tulip-100"
                          },
                          [
                            _c("BlIcon", {
                              staticClass: "w-6 h-6",
                              attrs: { icon: "warning", color: "tulip-7" }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col w-128" },
                              [
                                _vm.conflictedByRoom.length
                                  ? _c(
                                      "div",
                                      { staticClass: "flex flex-col" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("BlTextBody2", {
                                              staticClass: "text-tulip-700",
                                              attrs: {
                                                text: _vm.suffixRoomError
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.conflictedByRoom, function(
                                          date,
                                          idx
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: idx,
                                              staticClass:
                                                "flex items-center gap-2 px-2"
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "w-1 h-1 rounded bg-tulip-700"
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                staticClass: "text-tulip-700",
                                                attrs: { text: date }
                                              })
                                            ],
                                            1
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.conflictedByUser.length
                                  ? _c(
                                      "div",
                                      { staticClass: "flex flex-col" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _vm.conflictedByRoom.length
                                              ? _c("BlTextBody2", {
                                                  staticClass: "text-tulip-700",
                                                  attrs: {
                                                    text: "Additionally,"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("BlTextBody2", {
                                              staticClass: "text-tulip-700",
                                              attrs: {
                                                text: _vm.suffixUserError
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.conflictedByUser, function(
                                          date,
                                          idx
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: idx,
                                              staticClass:
                                                "flex items-center gap-2 px-2"
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "w-1 h-1 rounded bg-tulip-700"
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                staticClass: "text-tulip-700",
                                                attrs: { text: date }
                                              })
                                            ],
                                            1
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "text-tulip-700",
                                  attrs: {
                                    text:
                                      "Please adjust the details to proceed with the availability."
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.availability
                ? _c(
                    "div",
                    { staticClass: "absolute z-10 left-8 -bottom-14" },
                    [
                      _c(
                        "BlTooltip",
                        {
                          scopedSlots: _vm._u(
                            [
                              _vm.isDisabledDelete
                                ? {
                                    key: "tooltip",
                                    fn: function() {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex flex-col w-40 gap-1 text-center"
                                          },
                                          [
                                            _vm._v(
                                              "\n              This availability has in-progress and/or completed appointments\n              and cannot be removed.\n            "
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                : null
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("BlInputButton", {
                            attrs: {
                              type: "plain-error",
                              icon: "delete",
                              label: "Delete availability",
                              disabled: _vm.isDisabledDelete
                            },
                            on: {
                              clicked: function($event) {
                                _vm.deleteOpened = true
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.submitLoading
                ? _c(
                    "div",
                    { staticClass: "absolute z-10 right-56 -bottom-12" },
                    [_c("div", { staticClass: "blum-loader-btn" })]
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.recurringOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Edit recurring availabilities",
                label: "Update",
                description:
                  "You are modifying a recurring availability slot. Do you want to update only this slot or all future slots in the series?"
              },
              on: {
                "backdrop-close": _vm.onBackToEdit,
                "backdrop-action": _vm.onSubmit
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex flex-col gap-4 px-8",
                  style: { width: "40rem" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "grid items-center grid-cols-2 gap-2" },
                    _vm._l(_vm.updateOptionOptions, function(opt) {
                      return _c(
                        "div",
                        {
                          key: opt.value,
                          staticClass:
                            "flex flex-col items-center justify-center h-full px-4 py-4 text-center rounded cursor-pointer w-70",
                          class: [
                            opt.value === _vm.updateOptionInput
                              ? "border-2 border-light-purple bg-slate-100"
                              : "border border-slate-400 bg-pure-white m-px"
                          ],
                          on: {
                            click: function($event) {
                              _vm.updateOptionInput = opt.value
                            }
                          }
                        },
                        [
                          _c("BlTextSubtitle3", {
                            class: {
                              "text-light-purple":
                                opt.value === _vm.updateOptionInput
                            },
                            attrs: { text: opt.title }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.isShowInfoOrphanAppointments
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex items-start gap-2 px-3 py-2 rounded bg-cornflower-200"
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "w-6 h-6",
                            attrs: { icon: "info", color: "cornflower-8" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-cornflower-800",
                                attrs: {
                                  text: "By switching the availability from"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "font-bold text-cornflower-800",
                                attrs: { text: _vm.availability.user.name }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-cornflower-800",
                                attrs: { text: "to" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "font-bold text-cornflower-800",
                                attrs: { text: "'Open room'," }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-cornflower-800",
                                attrs: { text: "all" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "font-bold text-cornflower-800",
                                attrs: {
                                  text:
                                    _vm.impactedAppointment.count +
                                    " appointment(s)"
                                }
                              }),
                              _vm._v(" "),
                              _vm.updateOptionInput === "current"
                                ? _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: { text: "on" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.updateOptionInput === "current"
                                ? _c("BlTextBody2", {
                                    staticClass:
                                      "font-bold text-cornflower-800",
                                    attrs: {
                                      text:
                                        _vm.displayDate({
                                          date: _vm.availabilityDate,
                                          format: "DD MMMM YYYY"
                                        }) + ","
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.updateOptionInput === "current_and_following"
                                ? _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: { text: "from" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.updateOptionInput === "current_and_following"
                                ? _c("BlTextBody2", {
                                    staticClass:
                                      "font-bold text-cornflower-800",
                                    attrs: {
                                      text: _vm.displayDate({
                                        date: _vm.availabilityDate,
                                        format: "DD MMMM YYYY"
                                      })
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.updateOptionInput === "current_and_following"
                                ? _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: { text: "to" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.updateOptionInput === "current_and_following"
                                ? _c("BlTextBody2", {
                                    staticClass:
                                      "font-bold text-cornflower-800",
                                    attrs: {
                                      text:
                                        _vm.displayDate({
                                          date:
                                            _vm.impactedAppointment.last_date,
                                          format: "DD MMMM YYYY"
                                        }) + ","
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-cornflower-800",
                                attrs: {
                                  text:
                                    "will no longer have an assigned therapist and will need to be reassigned."
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Delete availability",
                label: "Delete",
                type: "error",
                disabled: _vm.conflictedAppointments.length,
                submitLoading: _vm.deleteLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteOpened = false
                },
                "backdrop-action": _vm.onDelete
              }
            },
            [
              !_vm.isRecurring
                ? _c(
                    "div",
                    { staticClass: "px-8" },
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "You are about to remove the availability slot from the schedule. If you proceed with deletion, the availability slot can be used by another therapist. Are you sure you want to proceed?"
                        }
                      })
                    ],
                    1
                  )
                : _c("div", { staticClass: "flex flex-col gap-4 px-8" }, [
                    _c(
                      "div",
                      [
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "This availability has been set as recurring slots until"
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "font-bold",
                          attrs: { text: _vm.endDatePreview }
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: "What action would you like to take?" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "grid items-center grid-cols-2 gap-2" },
                      _vm._l(_vm.deleteOptionOptions, function(opt) {
                        return _c(
                          "div",
                          {
                            key: opt.value,
                            staticClass:
                              "flex flex-col items-center justify-center h-full px-4 py-4 text-center rounded cursor-pointer w-70",
                            class: [
                              opt.value === _vm.deleteOptionInput
                                ? "border-2 border-light-purple bg-slate-100"
                                : "border border-slate-400 bg-pure-white m-px"
                            ],
                            on: {
                              click: function($event) {
                                _vm.deleteOptionInput = opt.value
                              }
                            }
                          },
                          [
                            _c("BlTextSubtitle3", {
                              class: {
                                "text-light-purple":
                                  opt.value === _vm.deleteOptionInput
                              },
                              attrs: { text: opt.title }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.conflictedAppointments.length
                      ? _c("div", { staticClass: "flex flex-col gap-2" }, [
                          _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                attrs: { text: "This action will affect" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "font-bold",
                                attrs: { text: _vm.totalConflictedAppointments }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: { text: "scheduled appointment(s)." }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "Please resolve the appointment(s) before proceeding with the deletion."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-col gap-1 px-4 py-3 overflow-y-auto rounded max-h-64 bg-slate-200"
                            },
                            _vm._l(_vm.conflictedAppointments, function(item) {
                              return _c(
                                "div",
                                {
                                  key: item.date,
                                  staticClass:
                                    "flex items-center justify-between"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center gap-2" },
                                    [
                                      _c("BlTextBody2", {
                                        staticClass: "text-slate-600",
                                        attrs: {
                                          text:
                                            _vm.displayDate({
                                              date: item.date
                                            }) + ":"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "text-slate-800",
                                        attrs: {
                                          text: item.count + " appointment(s)"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ee9e648", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee9e648","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/timeslot/EditAvailabilitiesModal.vue
// module id = null
// module chunks = 